/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Body.css";
import content from '../content.json';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import LoanOfficer from "../LoanOfficer/index.js";
import axios from "axios";

export default function Banner({ dataJson }) {

  const imgCDNURL = process.env.REACT_APP_HOMEOWNERSHIP_PROGRAM_CDN_URL;
  const [loanOfficerData, setLoanOfficerData] = useState(null);
  const { agentName } = useParams();
  const agentJsonName = agentName + ".json";
  const [loading, setLoading] = useState(true);
  const [loadBodyData, setLoadBodyData] = useState(true);
  const [agentData, setAgentData] = useState();
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [realorData, setRealtorData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [data, setData] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchAiBrandingJson = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setAiBrandingData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchAngelAiUserInfo = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGEL_AI_WEB_USER_INFO);
        setAngelAiUserInfo(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    const checkifLoanOfficerIsActive = async (loanOfficerId) => {
      try {
        const response = await axios.post(process.env.REACT_APP_CHECK_LO_ACTIVE, {
          loanOfficerId: loanOfficerId,
        });
        setLoanOfficerActive(response.data.active);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchAgentDetails = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_CDN +
          "swmc/jsons/loanOfficer/loanOfficerJson/" +
          agentJsonName
        );
        const responseData = response.data;
        setAgentData(responseData);
        await fetchAiBrandingJson();
        if (responseData) {
          setLoading(false);
          const loanOfficerId = responseData.loanOfficer.ssid;
          await checkifLoanOfficerIsActive(loanOfficerId);
          await fetchAngelAiUserInfo();
          setLoanOfficerData(responseData.loanOfficer);
          setRealtorData(responseData.realtor);
          setLoadBodyData(false);
        }
      } catch (error) {
        console.log("Error fetching agent details:", error);
      }
    };

    fetchAgentDetails();
  }, []);

  const { title, title2, title3, titleMobile, title2Mobile, title3Mobile, btnName, para } = dataJson;

  return (
    <>
      <div className="banner">
        <Container>
          <Row className="banner-row">
            <Col sm={12} md={12} lg={7} className='welcome-col'>
              <h1 className='title'>{parse(title)}</h1>
              <h1 className='titleMobile'>{parse(titleMobile)}</h1>
              <h2 className='title2'>{parse(title2)}</h2>
              <h2 className='title2Mobile'>{parse(title2Mobile)}</h2>
              <p className='para'>{parse(para)}</p>
            </Col>
            <Col sm={12} md={12} lg={5} className='Loanofficer-col'>
              <Suspense fallback={<div />}>
                <LoanOfficer
                  realtorData={realorData}
                  loanOfficerActive={loanOfficerActive}
                  loanOfficerData={loanOfficerData}
                  angelAiUserInfo={angelAiUserInfo}
                />
              </Suspense>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
